'use client';

import { Dialog, type DialogProps } from '@packages/shared/src/ui/Dialog/Dialog';

export const SearchFilterDialog = ({ children, ...props }: DialogProps) => (
  // Inert sentinel takes the dialog autofocus, so Safari does not paint a
  // focus ring on the first interactive element after touch input
  <Dialog {...props}>
    <div tabIndex={-1} className="outline-none" />
    {children}
  </Dialog>
);
